import {
  webRtcMessageId,
  mediaType,
  mediaStatus
} from "WEBSOCKET/constants";
import {
  ACTIONS,
  USER_ROLES,
  COMPONENT_IN_FOCUS,
  RECORDING_METHOD
} from "UTILS/Constants";
import {
  selectSnapshotPermissionReply
} from "REDUX/Selector/SessionSelector";
import { wsocket } from "WEBSOCKET/wsocket";
import { isIE } from "react-device-detect";

export const handleMessage = (data, store) => {
  switch (data.action) {
    case webRtcMessageId._WEBRTC_PERMISSION_REQUEST:
      store.dispatch({
        type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION,
        webRtcPermissionReply: null
      });
      store.dispatch({
        type: ACTIONS.SET_WEBRTC_REQUEST_PERMISSION,
        webRtcPermissionRequest: data.media
      });
      break;
    case webRtcMessageId._WEBRTC_PERMISSION_REPLY:
      let webRtcPermissionReply = store.getState().SessionReducer
      .webRtcPermissionReply;
      if (data.isGranted) {
        store.dispatch({
          type: ACTIONS.SET_WEBRTC_REQUEST_PERMISSION,
          webRtcPermissionRequest: data.media
        });
      }
      if (data.isGranted && webRtcPermissionReply === null) {
        store.dispatch({
          type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION,
          webRtcPermissionReply: true
        });
        // store.dispatch({
        //   type: ACTIONS.CALL_MODAL_PERMISSION,
        //   value: true
        // })
      } 
      if(!data.isCameraConnected || !data.isMicConnected || !data.isGranted) {
        //TODO show notification
        const permissionStatus = {
          isGranted: data.isGranted,
          uniqueId: data.remoteId,
          media: data.media,
          isCameraConnected: data.isCameraConnected,
          isMicConnected: data.isMicConnected,
          isPluginInstalled: data.isPluginInstalled
        };
        store.dispatch({
          type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION_STATUS,
          webRtcPermissionReplyStatus: permissionStatus
        });
      }

      if(!data.isPluginInstalled){
        store.dispatch({
          type: ACTIONS.USER_PLUGIN_NOT_INSTALLED,
          participantId: data.remoteId
        });
      }
      break;
    case webRtcMessageId._SHARE_WEBRTC_MEDIA:
      console.log("_SHARE_WEBRTC_MEDIA" + data.media);
      const recordingMethod = store.getState().SessionReducer.sessionDetails.recordingMethod;
      store.dispatch({
        type: ACTIONS.ERROR.KMS_CONNECTED,
        value: true
      });
      if (data.media === mediaType.SCREEN) {    // Screenshare
        store.dispatch({
          type: ACTIONS.SAVE_SCREENSHARING_PARTICIPANT_ID,
          screenSharingParticipantId: data.participantId
        });
        startVideoTimer(data, store);
        if (recordingMethod === RECORDING_METHOD.AUTO
          && data.recordingVideoStarted) {
          store.dispatch({
            type: ACTIONS.SET_IS_RECORDING,
            value: true,
          });
        }
      } else if (       // audio / video call
        data.media === mediaType.AUDIO ||
        data.media === mediaType.AUDIO_VIDEO
      ) {
        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_TYPE,
          participant: {
            uniqueId: data.participantId,
            mediaType: data.media
          }
        });
        store.dispatch({
          type: ACTIONS.SET_CALL_MEDIA_TYPE,
          mediaType: data.media
        });
        store.dispatch({
          type: ACTIONS.CALL_MODAL_PERMISSION,
          value: true
        })
        if ( data.media === mediaType.AUDIO_VIDEO ) {
          startVideoTimer(data, store);
        }
        if (recordingMethod === RECORDING_METHOD.AUTO 
          && ( data.recordingVideoStarted || data.recordingAudioStarted )) {
          store.dispatch({
            type: ACTIONS.SET_IS_RECORDING,
            value: true,
          });
        }
        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_STATUS,
          participant: {
            uniqueId: data.participantId,
            audioStatus: data.audioStatus,
            videoStatus: data.videoStatus,
          }
        });
      }
      break;

    case webRtcMessageId._NEW_WEBRTC_MEDIA:
      console.log("_NEW_WEBRTC_MEDIA", JSON.stringify(data));
      if (data.media === mediaType.SCREEN) {
        store.dispatch({
          type: ACTIONS.SAVE_SCREENSHARING_PARTICIPANT_ID,
          screenSharingParticipantId: data.participantId
        });
      } else if (
        data.media === mediaType.AUDIO ||
        data.media === mediaType.AUDIO_VIDEO
      ) {
        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_TYPE,
          participant: {
            uniqueId: data.participantId,
            mediaType: data.media
          }
        });
        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_STATUS,
          participant: {
            uniqueId: data.participantId,
            audioStatus: data.audioStatus,
            videoStatus: data.videoStatus,
          }
        });
      }
      break;
    case webRtcMessageId._STOP_SCREEN_SHARING:
      stopScreenSharing(store);
      break;
    case webRtcMessageId._SDP_ANSWER:
      console.log("_SDP_ANSWER", JSON.stringify(data));
      if (data.media === mediaType.SCREEN) {  // screen share
        wsocket.screenShareRtcPeer &&
          wsocket.screenShareRtcPeer.processAnswer(data.sdpAnswer, function (
            error
          ) {
            if (error) {
              console.error("processAnswer ", error);
            }
          });
      } else if (     // audio or video call
        data.media === mediaType.AUDIO ||     
        data.media === mediaType.AUDIO_VIDEO
      ) {

        wsocket.audioAndVideoRtcPeer[data.participantId] &&
        wsocket.audioAndVideoRtcPeer[data.participantId][data.media] &&
          wsocket.audioAndVideoRtcPeer[data.participantId][data.media].processAnswer(
            data.sdpAnswer,
            function (error) {
              if (error) {
                console.error("processAnswer ", error);
              }
            }
          );
        /*Check if Audio is disabled for particular user before allowing the Microphone permission of browser 
          then audio of rtc peer is not disabled. So after get sdp we need to set audioEnabled false to mute that user.
        (after allowing the browser's permission gets SDP offer)*/
        store.getState().ParticipantReducer.participants.forEach(participant => {
          
          if ((participant.audioStatus === mediaStatus.MUTED || 
            participant.audioStatus === mediaStatus.MUTED_BY_AGENT) && 
              wsocket.audioAndVideoRtcPeer[participant.uniqueId] && 
              wsocket.audioAndVideoRtcPeer[participant.uniqueId].AUDIO && 
            wsocket.audioAndVideoRtcPeer[participant.uniqueId].AUDIO.audioEnabled) {

            wsocket.audioAndVideoRtcPeer[participant.uniqueId].AUDIO.audioEnabled = false
          }
        })
        //TODO: Since we have a requirement of having user's join as muted
      } else if (data.media === mediaType.VIDEO) {
        if (data.isSnapshot) {
          wsocket.snapshotRtcPeer && wsocket.snapshotRtcPeer.processAnswer(data.sdpAnswer, function (
            error
          ) {
            if (error) {
              console.error("processAnswer ", error);
            }
          });
        }
        else {

          wsocket.audioAndVideoRtcPeer[data.participantId] &&
          wsocket.audioAndVideoRtcPeer[data.participantId][data.media]&&
            wsocket.audioAndVideoRtcPeer[data.participantId][data.media].processAnswer(
              data.sdpAnswer,
              function (error) {
                if (error) {
                  console.error("addIceCandidate ", error);
                }
              }
            );
        }
      }
      break;
    case webRtcMessageId._ICE_CANDIDATE:
      console.log("_ICE_CANDIDATE: ", JSON.stringify(data));
      if (data.media === mediaType.SCREEN && wsocket.screenShareRtcPeer) {
        wsocket.screenShareRtcPeer.addIceCandidate(data.candidate, function (
          error
        ) {
          if (error) {
            console.error("addIceCandidate ", error);
          }
        });
      } else if (
        (data.media === mediaType.AUDIO ||
          data.media === mediaType.AUDIO_VIDEO) &&
        wsocket.audioAndVideoRtcPeer[data.participantId] &&
        wsocket.audioAndVideoRtcPeer[data.participantId][data.media]
      ) {

        wsocket.audioAndVideoRtcPeer[data.participantId][data.media].addIceCandidate(
          data.candidate,
          function (error) {
            if (error) {
              console.error("addIceCandidate ", error);
            }
          }
        );
      } else if (data.media === mediaType.VIDEO) {
        if (data.isSnapshot) {
          wsocket.snapshotRtcPeer && wsocket.snapshotRtcPeer.addIceCandidate(data.candidate, function (
            error
          ) {
            if (error) {
              console.error("addIceCandidate ", error);
            }
          });
        }
        else {
          wsocket.audioAndVideoRtcPeer[data.participantId] &&
          wsocket.audioAndVideoRtcPeer[data.participantId][data.media] && 
          wsocket.audioAndVideoRtcPeer[data.participantId][data.media].addIceCandidate(
            data.candidate,
            function (error) {
              if (error) {
                console.error("addIceCandidate ", error);
              }
            }
          );
        }
      }
      break;
    case webRtcMessageId._STOP_ALL_WEBRTC_AUDIO_VIDEO:
      stopAudioVideoCall(store);
      store.dispatch({
        type: ACTIONS.CALL_STATUS,
        value: true
      });
      break;
    //SNAPSHOT START
    case webRtcMessageId._SNAPSHOT_PERMISSION_REQUEST:
      store.dispatch({
        type: ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY,
        snapshotPermissionReply: null
      });
      store.dispatch({
        type: ACTIONS.SET_SNAPSHOTER_ID,
        snapshoterId: data.snapshoterId
      });
      store.dispatch({
        type: ACTIONS.SET_SNAPSHOTEE_ID,
        snapshoteeId: store.getState().SessionReducer.uniqueId
      });
      break;
    case webRtcMessageId._SNAPSHOT_PERMISSION_REPLY:
      //Check snapshotee user already in Video call
      //NOW Set flag to create rtc peer for snapshot
      
      // let state = store.getState();
      // let isVideoCallRunning = false
      // if(data.isGranted && 
      //     state.RoomMetaDataReducer.roomMetaData.organiser !== state.SessionReducer.uniqueId && 
      //     data.isUserWebCamPresent !== false){
      //   state.ParticipantReducer.participants.forEach(participant => {
      //     if (participant.uniqueId === data.snapshoteeId && !isVideoCallRunning) {
      //       isVideoCallRunning = participant.mediaType === mediaType.AUDIO_VIDEO
      //     }
      //   })
      // }
      // //is Snapshotee user not in call then proceed for normal snapshot execution
      // if(!isVideoCallRunning){
      const permissionStatus = {
        isUserWebCamPresent: data.isUserWebCamPresent,
        isPluginInstalled: data.isPluginInstalled,
        isPluginExpired: data.isPluginExpired,
      }
      store.dispatch({
        type: ACTIONS.SET_SNASHOT_PERMISSION_STATUS,
        snapshotPermissionStatus: permissionStatus
      });
      store.dispatch({
        type: ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY,
        snapshotPermissionReply: data.isGranted
      });
      store.dispatch({
        type: ACTIONS.SET_SNAPSHOTEE_ID,
        snapshoteeId: data.isGranted ? data.snapshoteeId : ""
      });
      store.dispatch({
        type: ACTIONS.CREATE_SNAPSHOT_RTC_PEER,
        value: data.isGranted
      }) 
      // }
      // else{
      //   // if Snapshotee user is in video call then stop video call first
      //   // store.dispatch({
      //   //   type: ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY,
      //   //   snapshotPermissionReply: true
      //   // });
      //   store.dispatch({
      //     type:ACTIONS.STOP_VIDEO_CALL,
      //     value:true
      //   })
      // }
      break;
    case webRtcMessageId._SWITCH_SNAPSHOT_CAMERA:
      if (wsocket.snapshotRtcPeer) {
        wsocket.snapshotRtcPeer.dispose();
        wsocket.snapshotRtcPeer = null;
        store.dispatch({
          type: ACTIONS.SET_SWITCH_CAMERA,
          isPeerDisposed: true,
        });
      }
      break;
    case webRtcMessageId._SNAPSHOT_TAKEN:
      stopSnapshot(data, store);
      break;
    //SNAPSHOT END
    case webRtcMessageId._MEDIA_TOGGLED:
      if (data.media === mediaType.AUDIO) {
        if (wsocket.audioAndVideoRtcPeer[data.remoteId] &&
          wsocket.audioAndVideoRtcPeer[data.remoteId][data.media]) {
          wsocket.audioAndVideoRtcPeer[data.remoteId][data.media].audioEnabled =
            (data.mediaStatus === mediaStatus.MUTED
            || data.mediaStatus === mediaStatus.MUTED_BY_AGENT)
              ? false 
              : true;
        }

        if(!isIE && data.remoteId === store.getState().SessionReducer.uniqueId) {
          let sender = wsocket.audioAndVideoRtcPeer[data.remoteId]["AUDIO"].peerConnection.getSenders().find(function (s) {
            return s.track.kind == 'audio';
          });
          if(sender && sender.track) {
          // if audioStatus is muted enable audio for unmuting
            sender.track.enabled = data.mediaStatus === mediaStatus.UNMUTED ? true : false;
            console.log('sender.track.enabled: ', sender.track.enabled, data);
          }
        }

        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_STATUS,
          participant: {
            uniqueId: data.remoteId,
            audioStatus: data.mediaStatus,
            mediaStatusChangeByAgent: data.participantId !== data.remoteId
          },
          uniqueId: store.getState().SessionReducer.uniqueId
        });
      } else if (data.media === mediaType.AUDIO_VIDEO) {
        if (wsocket.audioAndVideoRtcPeer[data.remoteId] &&
          wsocket.audioAndVideoRtcPeer[data.participantId][mediaType.VIDEO]) {
          wsocket.audioAndVideoRtcPeer[data.remoteId][mediaType.VIDEO].videoEnabled =
          (data.mediaStatus === mediaStatus.MUTED
          || data.mediaStatus === mediaStatus.MUTED_BY_AGENT)
            ? false 
            : true;
        }

        store.dispatch({
          type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_STATUS,
          participant: {
            uniqueId: data.remoteId,
            videoStatus: data.mediaStatus,
            mediaStatusChangeByAgent: data.participantId !== data.remoteId
          },
          uniqueId: store.getState().SessionReducer.uniqueId
        });
      }
      break;
    // KMS Status Handling
    case webRtcMessageId._KMS_DISCONNECTED:
      store.dispatch({
        type: ACTIONS.ERROR.KMS_NOT_CONNECTED,
        value: false
      });
      break;
    // case webRtcMessageId._KMS_RECONNECTED:
    //   store.dispatch({
    //     type: ACTIONS.ERROR.KMS_CONNECTED,
    //     value: true
    //   });
    //   break;
    case webRtcMessageId._WEBRTC_SESSION_STARTED:
      store.dispatch({
        type: ACTIONS.SET_WEBRTC_SESSION_MEDIA,
        value: data.media
      });
      break;
    case webRtcMessageId._RELEASE_ALL_REMOTE_MEDIA:
      if(store.getState().SessionReducer.webRtcPermissionRequest === mediaType.AUDIO_VIDEO
        || store.getState().SessionReducer.webRtcPermissionRequest === mediaType.AUDIO) {
        stopAudioVideoCall(store);
      }
      if(wsocket.screenShareRtcPeer) {
        stopScreenSharing(store);
      }
      if(store.getState().SessionReducer.snapshoteeId) {
        stopSnapshot(data, store);
      }
      break;
    case webRtcMessageId._STOP_USER_VIDEO:
      console.log('_STOP_USER_VIDEO: ');
      // Video call need to stop first in case user accept snapshot reqest.
      let stateForStopUserVideo = store.getState()
      if (
        data.participantId &&
        wsocket.audioAndVideoRtcPeer[data.participantId] !== undefined &&
        wsocket.audioAndVideoRtcPeer[data.participantId].VIDEO 
      ) {
        wsocket.audioAndVideoRtcPeer[data.participantId].VIDEO.dispose(); // dispose RTC peer
        delete wsocket.audioAndVideoRtcPeer[data.participantId].VIDEO;
      }
      //update participant mediaType = AUDIO 
      store.dispatch({
        type: ACTIONS.UPADTE_PARTICIPANT_MEDIA_TYPE,
        participant: {
          uniqueId: data.participantId,
          mediaType: mediaType.AUDIO
        }
      })
      if(store.getState().SessionReducer.snapshoteeId && store.getState().SessionReducer.snapshotPermissionReply) {
        if(stateForStopUserVideo.SessionReducer.uniqueId !== stateForStopUserVideo.RoomMetaDataReducer.roomMetaData.organiser &&
          stateForStopUserVideo.SessionReducer.webRtcPermissionRequest && stateForStopUserVideo.SessionReducer.webRtcPermissionReply
        ){// start snapshot
          store.dispatch({
            type: ACTIONS.START_SNAPSHOT,
            value: true
          }) 
        }
      } else {
        // start video again 
        store.dispatch({
          type: ACTIONS.START_VIDEO_CALL,
          value: true
        })
      }
      break;
    case webRtcMessageId._PLUGIN_NOT_INSTALLED:
      store.dispatch({
        type: ACTIONS.USER_PLUGIN_NOT_INSTALLED,
        participantId: data.participantId
      });
      break;
    case webRtcMessageId._SNAPSHOT_STARTED:
      store.dispatch({
        type: ACTIONS.SNAPSHOT.SET_SNAPSHOT_STATUS,
        value: true
      });
      break;
    case webRtcMessageId._SNAPSHOT_STOPPED:
      store.dispatch({
        type: ACTIONS.SNAPSHOT.SET_SNAPSHOT_STATUS,
        value: false
      });
      break;
    case webRtcMessageId._SET_IS_RECORDING:
      store.dispatch({
        type: ACTIONS.SET_IS_RECORDING,
        value: data.isRecording,
      });
      break;
    case webRtcMessageId._SET_IS_SCREEN_MASKING:
      store.dispatch({
        type: ACTIONS.SET_IS_SCREEN_MASKING,
        value: data.isScreenMasking,
      });
      break;
    default:
      break;
  }
};

function stopAudioVideoCall(store) {
  store.getState().ParticipantReducer.participants.map(participant => {
    if (
      participant &&
      wsocket.audioAndVideoRtcPeer[participant.uniqueId] !== undefined
    ) {
      Object.keys(wsocket.audioAndVideoRtcPeer[participant.uniqueId]).map((key) => {
        wsocket.audioAndVideoRtcPeer[participant.uniqueId][key].dispose();
      });
    }
  });
  store.dispatch({
    type: ACTIONS.SET_LOCAL_STREAM,
    localStream: null
  });
  store.dispatch({
    type: ACTIONS.CALL_MODAL_PERMISSION,
    value: false
  });
  if(store.getState().SessionReducer.componentInfocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO){
    store.dispatch({
      type: ACTIONS.SET_COMPONENT_IN_FOCUS,
      componentInFocus: COMPONENT_IN_FOCUS.CANVAS
    });
  }
  store.dispatch({
    type : ACTIONS.SET_SORTED_PARTICIPANT,
    sortedParticipants : []
  });
  wsocket.audioAndVideoRtcPeer = [];
  let webRtcPermissionRequest = store.getState().SessionReducer
  .webRtcPermissionRequest;
  store.dispatch({
    type: ACTIONS.RESET_ALL_PARTICIPANT_MEDIA_STATUS
  });
  store.dispatch({
    type: ACTIONS.UPDATE_HEADER_ICON_CLASSNAME,
    data: {
      moduleName: mediaType.AUDIO,
      classname: store.getState().UserReducer.userDetails.role === USER_ROLES.USER ? "moduleIcon cursorDisabled" : "moduleIcon",
      textLabelClass: store.getState().UserReducer.userDetails.role === USER_ROLES.USER ? " cursorDisabled" : " cursorPointer"
    }
  });
  store.dispatch({
    type: ACTIONS.UPDATE_HEADER_ICON_CLASSNAME,
    data: {
      moduleName: mediaType.AUDIO_VIDEO,
      classname: store.getState().UserReducer.userDetails.role === USER_ROLES.USER ? "moduleIcon cursorDisabled" : "moduleIcon",
      textLabelClass: store.getState().UserReducer.userDetails.role === USER_ROLES.USER ? " cursorDisabled" : " cursorPointer"
    }
  });
  if (document.pictureInPictureElement) {
    document.exitPictureInPicture();
  }
}

function stopScreenSharing(store) {
  if (wsocket.screenShareRtcPeer !== null) {
    wsocket.screenShareRtcPeer.dispose();
    wsocket.screenShareRtcPeer = null;
  }
  store.dispatch({
    type: ACTIONS.SAVE_SCREENSHARING_PARTICIPANT_ID,
    screenSharingParticipantId: null
  });
}

function stopSnapshot(data, store) {
  if (wsocket.snapshotRtcPeer !== null) {
    wsocket.snapshotRtcPeer.dispose();
    wsocket.snapshotRtcPeer = null;
  }

  store.dispatch({
    type: ACTIONS.CREATE_SNAPSHOT_RTC_PEER,
    value: false
  })
  store.dispatch({
    type: ACTIONS.START_SNAPSHOT,
    value: false
  });

  let snapshotPermissionReply = selectSnapshotPermissionReply(store.getState());
  // reset snapshot data for agent only when permission is granted by snapshotee on receiving _SNAPSHOT_TAKEN message
  // always reset snapshot data for user on receiving _SNAPSHOT_TAKEN message
  if (store.getState().SessionReducer
    && (store.getState().SessionReducer.snapshoteeId != store.getState().SessionReducer.uniqueId
      && snapshotPermissionReply === true)
    || (store.getState().SessionReducer.snapshoteeId === store.getState().SessionReducer.uniqueId)) {
    store.dispatch({
      type: ACTIONS.RESET_SNAPSHOT_DATA
    });
  }
  
  if (data.isCameraPermissionGranted && !data.isCameraBusy) {
    store.dispatch({
      type: ACTIONS.SET_SNAPSHOT_TAKEN,
      isSnapshotTaken: data.isSnapshotTaken
    });
  }
  else if(data.isCameraBusy){
    store.dispatch({
      type: ACTIONS.SET_CAMERA_BUSY_FLAG,
      value: data.isCameraBusy
    });
  }
  else {
    store.dispatch({
      type: ACTIONS.SNAPSHOT.SET_SNAPSHOT_CAMERA_PERMISSION,
      value: data.isCameraPermissionGranted
    });
  }
}

function startVideoTimer(data, store) {
  /* TODO 
  if ( data.recordingVideoStarted && wsocket.videoTimer == null ) {
    wsocket.videoTimer = setTimeout((data, store) => {
      // TODO 録画停止処理
      // TODO store.dispatch(録画停止しました)

      wsocket.videoTimer = null;
    }, (180 * 60 * 1000), data, store);
    // TODO 最大時間もサーバー側から受け取る必要あり
  }
  */
}
function cancelVideoTimer() {
  // TODO 呼び出し元検討中
  // TODO 録画が終わった(ビデオ通話、画面共有の両方)の判定
  if ( wsocket.videoTimer != null ) {
    clearTimeout(wsocket.videoTimer);
    wsocket.videoTimer = null;
  }
}